'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function cbChatFormDirective($interval) {
    return {
        restrict: 'A',
        scope: {
            showKassabonButton: '='
        },
        controller: 'chatFormController',
        controllerAs: 'chatFormController',
        link: function link($scope, $element) {
            var animationInterval = void 0;
            $scope.chatFormController.setElement($element[0]);
            $scope.chatFormController.init();
            $scope.chatFormController.checkFormPresent = function () {
                if ($element[0].innerHTML !== 'dezedivisleeg') {
                    $scope.showKassabonButton = true;
                    $scope.chatFormController.setFormPresent(true);
                } else {
                    $scope.showKassabonButton = false;
                    $scope.chatFormController.setFormPresent(false);
                }
                $scope.$apply();
            };

            $scope.chatFormController.bringToAttention = function () {
                var maxAnimations = 5;
                var kassabonButtonHolder = angular.element('.chat__buttons');
                var kassabonButton = kassabonButtonHolder.find('.chat__buttons-button');
                var currentAnimation = 0;

                animationInterval = $interval(function () {
                    kassabonButtonHolder[0].classList.toggle('chat__buttons--blink', currentAnimation % 2 !== 0);
                    kassabonButton[0].classList.toggle('chat__buttons-button--blink', currentAnimation % 2 !== 0);
                    currentAnimation++;
                    if (currentAnimation === maxAnimations) {
                        kassabonButtonHolder[0].classList.toggle('chat__buttons--blink', false);
                        kassabonButton[0].classList.toggle('chat__buttons-button--blink', false);
                        $interval.cancel(animationInterval);
                    }
                }, 250);
            };

            $scope.$on('$destroy', function () {
                if (animationInterval) {
                    $interval.cancel(animationInterval);
                }
                $scope.chatFormController.observer.disconnect();
            });
        }
    };
}

cbChatFormDirective.$inject = ['$interval'];

exports.default = cbChatFormDirective;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/chat/cb-chat-form.directive.js
// module id = 864
// module chunks = 0